import { combineReducers } from "redux";
import authReducer from "./authReducer";
import modalReducer from "./modalReducer";
import projectReducer from "./projectReducer";
import jobReducer from "./jobReducer";
import jobLogsReducer from "./jobLogsReducer";

const appReducer = combineReducers({
  auth: authReducer,
  modal:modalReducer,
  projects: projectReducer,
  jobs: jobReducer,
  jobLogs: jobLogsReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};
export default rootReducer;
